import { InfoBox } from "./InfoBox";
import type { InfoBoxProps } from "./types";

export { InfoBox, InfoBoxProps };
